module.exports = __webpack_public_path__ + "static/media/EasyWords_web_1_preview.b73ce234.jpg";